export default "__VITE_ASSET__wSLN9MXE__"